import type { LineConfig } from 'src/features/forecast/types/LineConfig';

export const linesConfig: LineConfig[] = [
  {
    dataKey: 'realSales',
    yAxisId: 'sales',
    stroke: 'var(--chart-real-sales)',
    strokeWidth: 2,
    dot: {
      fill: 'var(--chart-real-sales)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'validatedForecast',
    yAxisId: 'sales',
    stroke: 'var(--chart-validated-forecast)',
    strokeWidth: 1.5,
    strokeDasharray: '8 4',
    dot: {
      fill: 'var(--chart-validated-forecast)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'b2bSales',
    yAxisId: 'sales',
    stroke: 'var(--chart-b2b-sales)',
    strokeWidth: 1,
    dot: {
      fill: 'var(--chart-b2b-sales)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'productPriceIndex',
    yAxisId: 'price',
    stroke: 'var(--chart-product-price)',
    strokeWidth: 1,
    strokeDasharray: '10 10',
    dot: {
      fill: 'var(--chart-product-price)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'realSalesAverage',
    yAxisId: 'sales',
    stroke: 'var(--chart-real-sales-average)',
    strokeWidth: 2,
    dot: {
      fill: 'var(--chart-real-sales-average)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'forecastProposal',
    yAxisId: 'sales',
    stroke: 'var(--chart-forecast-proposal)',
    strokeWidth: 3,
    dot: {
      fill: 'var(--chart-forecast-proposal)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'modelProposal',
    yAxisId: 'sales',
    stroke: 'var(--chart-model-proposal)',
    strokeWidth: 1,
    strokeDasharray: '8 4',
    dot: {
      fill: 'var(--chart-model-proposal)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'modelProposal2',
    yAxisId: 'sales',
    stroke: 'var(--chart-model-proposal-2)',
    strokeWidth: 1,
    strokeDasharray: '8 4',
    dot: {
      fill: 'var(--chart-model-proposal-2)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'line',
  },
  {
    dataKey: 'stock',
    yAxisId: 'stock',
    stroke: 'var(--chart-stock)',
    strokeWidth: 0.5,
    dot: {
      fill: 'var(--chart-stock)',
      strokeWidth: 0,
      r: 0,
    },
    connectNulls: false,
    chartType: 'area',
    fill: 'url(#stockGradient)',
    fillOpacity: 0.7,
  },
];
